export function numberWithCommas(n: number | string) {
  return n.toLocaleString('en-US', {
    style: 'decimal',
  });
}
